export const receiptCard_master = {    
    default: {
        backgroundColor: '#007aff',
        color: '#fff',
        '& hr': {
            borderColor: '#0147fe',
        },
        '& a.link': {
            color: '#fff !important',
        }
    },
    white : {},
    yellow: {
        backgroundColor: '#ffb401',
        color: '#171717',
        '& hr': {
            borderColor: '#f5a623',
        },
        '& a.link': {
            color: '#171717 !important',
        }
    },
}